const THRESHOLD = 0.5;
const CURRENT_CLASS = "is-current";

for (const carousel of document.querySelectorAll<HTMLElement>(".carousel")) {
  const viewport = carousel.querySelector<HTMLElement>(".carousel__slides");
  if (viewport == null) throw new Error("Carousel with no viewport");

  const slides = viewport.querySelectorAll<HTMLElement>(".carousel__slide");
  const pips = carousel.querySelectorAll<HTMLElement>(
    ".carousel__nav .carousel__nav__pip"
  );
  if (slides.length !== pips.length)
    throw new Error("Slides length is not the same as pips length");

  // Handle clicks on pips
  for (const [index, pip] of pips.entries()) {
    pip.addEventListener("click", () => {
      viewport.scrollTo({
        left: slides[index].offsetLeft,
        behavior: "smooth",
      });
    });
  }

  // Keep track of which slide is current
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        const index = [...slides].findIndex((slide) => slide === entry.target);
        if (index === -1) continue;
        const pip = pips[index];
        pip.classList.toggle(
          CURRENT_CLASS,
          entry.intersectionRatio >= THRESHOLD
        );
      }
    },
    {
      root: viewport,
      threshold: THRESHOLD,
    }
  );
  for (const slide of slides) {
    observer.observe(slide);
  }

  const prevSlide = carousel.querySelector<HTMLElement>(
    ".carousel__nav .carousel__nav__arrow--prev"
  );
  const nextSlide = carousel.querySelector<HTMLElement>(
    ".carousel__nav .carousel__nav__arrow--next"
  );
  // Handle clicks on prev slide nav
  prevSlide?.addEventListener("click", () => {
    const prevPipAttr = carousel
      .querySelector<HTMLElement>(
        ".carousel__nav .carousel__nav__pip.is-current"
      )
      ?.getAttribute("data-prev");
    carousel
      .querySelector<HTMLElement>(
        ".carousel__nav .carousel__nav__pip[data-current='" + prevPipAttr + "']"
      )
      ?.click();
  });

  // Handle clicks on next slide nav
  nextSlide?.addEventListener("click", () => {
    const nextPipAttr = carousel
      .querySelector<HTMLElement>(
        ".carousel__nav .carousel__nav__pip.is-current"
      )
      ?.getAttribute("data-next");
    carousel
      .querySelector<HTMLElement>(
        ".carousel__nav .carousel__nav__pip[data-current='" + nextPipAttr + "']"
      )
      ?.click();
  });

  // Scroll current slide into view on resize
  window.addEventListener("resize", () => {
    const index = [...pips].findIndex((pip) =>
      pip.classList.contains(CURRENT_CLASS)
    );
    const slide = slides[Math.max(0, index)];
    viewport.scrollTo({
      left: slide.offsetLeft,
      behavior: "auto",
    });
  });

  // Update the carousel class based on slideshow scroll position
  const updateSlideshowClasses = (): void => {
    const partialWidth = (viewport.clientWidth / 4) * 3;
    const scrollPos = viewport.scrollLeft;
    const slideshowWidth = viewport.clientWidth * (pips.length - 1);
    if (scrollPos <= partialWidth) {
      carousel.classList.add("disable-prev");
    } else {
      carousel.classList.remove("disable-prev");
    }
    if (scrollPos >= slideshowWidth - partialWidth) {
      carousel.classList.add("disable-next");
    } else {
      carousel.classList.remove("disable-next");
    }
  };

  updateSlideshowClasses();
  viewport.addEventListener("scroll", updateSlideshowClasses);
}
